import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardContent,
  CardHeader,
  Button,
  Table as MUITable,
  TableCell,
  TableRow,
  Typography,
} from "@material-ui/core";
import { Table } from "antd";
import { toJS } from "mobx";
import styled from "styled-components";
import { colours } from "../../utilities/styles";
import Modal from "../../atoms/modal/index";
import AddGroupForm from "../addGroupForm";

const StyledArticle = styled.article`
  font-size: 24px;
  text-align: center;
  font-weight: bold;
  margin-bottom: $content_margin;
`;

const GroupOverviewTable = ({
  comparedGroups,
  columns,
  loading,
  pagination,
  onTableChange,
  fetchComparedGroups,
}) => {
  const [tableData, setTableData] = useState();
  const [total, setTotal] = useState();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (comparedGroups) {
      setTableData(toJS(comparedGroups).filter((e) => e.group_name !== "TOTAL COMPANY"));
      const filterTotal = toJS(comparedGroups).filter((e) => e.group_name === "TOTAL COMPANY");
      setTotal(...filterTotal);
    }
  }, [comparedGroups]);

  return (
    <>
      <StyledArticle>Group overview</StyledArticle>
      <StyledArticle className="subHeading">
        <h6>Get a better view of the different groups in the organization!</h6>
      </StyledArticle>
      <Card>
        <CardHeader
          title={
            <Button
              style={{ background: colours.yomento_purple, color: "#fff" }}
              onClick={() => setShowModal(true)}
            >
              Add Group
            </Button>
          }
        />
        <CardContent>
          <Table
            style={{ border: "1px solid $border_color" }}
            dataSource={tableData}
            rowKey={(group) => group.group_name}
            columns={columns}
            loading={loading}
            pagination={pagination}
            onChange={onTableChange}
          />
          {total && (
            <MUITable
              style={{ border: "1px solid $border_color" }}
              dataSource={total}
              columns={columns}
            >
              <TableRow>
                <TableCell style={{ width: "400px" }}>
                  <Typography variant="body1" style={{ fontWeight: "bold" }}>
                    {total.group_name}
                  </Typography>
                </TableCell>
                <TableCell align="left">
                  <Typography variant="body1" style={{ fontWeight: "bold" }}>
                    {total.group_active_members}
                  </Typography>
                </TableCell>
                <TableCell align="left">
                  <Typography variant="body1" style={{ fontWeight: "bold" }}>
                    {total.days30Ratio}
                  </Typography>
                </TableCell>
                <TableCell align="left">
                  <Typography variant="body1" style={{ fontWeight: "bold" }}>
                    {total.group_average_sessions}
                  </Typography>
                </TableCell>
                <TableCell style={{ paddingRight: "30px" }} />
              </TableRow>
            </MUITable>
          )}
        </CardContent>
      </Card>

      <Modal
        open={showModal}
        onClose={() => setShowModal(false)}
        header="Create a new group"
        actions={
          <AddGroupForm setShowModal={setShowModal} fetchComparedGroups={fetchComparedGroups} />
        }
      />
    </>
  );
};

GroupOverviewTable.propTypes = {
  comparedGroups: PropTypes.objectOf(PropTypes.any).isRequired,
  columns: PropTypes.arrayOf(PropTypes.any).isRequired,
  loading: PropTypes.bool.isRequired,
  pagination: PropTypes.bool.isRequired,
  onTableChange: PropTypes.func.isRequired,
};

export default GroupOverviewTable;
